import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import Button from '@mui/material/Button'

const FileUploadPopup = ({ open, close, title, accept, save }) => {

  const handleUpload = async e => {
    let file = e.target.files[0]

    let reader = new FileReader()

    const get_data = e => {
      let data = e.target.result
      save(data,file)
      close()
    }

    const on_reader_load = () => get_data

    // Closure to capture the file information.
    reader.onload = on_reader_load()

    const filetype = file.name.split(".").pop()

    switch(filetype) {
      case "csv" :
      case "json" : {
        reader.readAsText(file)
        break
      }
      case "xlsx" : {
        reader.readAsArrayBuffer(file)
        break
      }
    }
  }

  if (open) return (
    <Dialog onClose={close} open={open} sx={{
      "& .MuiDialog-container": {
        "& .MuiPaper-root": {
          width: "600px",
          maxWidth: "600px"
        },
      },
    }}>
      <div className="popupFieldEditor">

        <DialogTitle>{title}</DialogTitle>

        <input type="file" accept={accept} onChange={handleUpload} />

        <hr />

        <div className="flex flex-row w-full justify-between">
          <Button variant="outlined" onClick={close}>Cancel</Button>
        </div>
      </div>
    </Dialog>
  )
}

export default FileUploadPopup